export const CoinIcon = ({ size = 20, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Outer coin circle with gradient */}
    <defs>
      <radialGradient id="coinGrad" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#FDE68A" />
        <stop offset="40%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#B45309" />
      </radialGradient>
      <radialGradient id="coinShine" cx="35%" cy="30%" r="50%">
        <stop offset="0%" stopColor="#FEF9C3" stopOpacity="0.8" />
        <stop offset="100%" stopColor="#FDE68A" stopOpacity="0" />
      </radialGradient>
    </defs>
    {/* Shadow */}
    <ellipse cx="12" cy="21" rx="7" ry="1.5" fill="#92400E" opacity="0.25" />
    {/* Coin body */}
    <circle cx="12" cy="11.5" r="9" fill="url(#coinGrad)" />
    {/* Rim */}
    <circle cx="12" cy="11.5" r="9" fill="none" stroke="#B45309" strokeWidth="0.8" opacity="0.6" />
    {/* Inner ring */}
    <circle cx="12" cy="11.5" r="7" fill="none" stroke="#FCD34D" strokeWidth="0.6" opacity="0.7" />
    {/* Shine overlay */}
    <circle cx="12" cy="11.5" r="9" fill="url(#coinShine)" />
    {/* Dollar / coin symbol */}
    <text
      x="12"
      y="16"
      textAnchor="middle"
      fontSize="9"
      fontWeight="bold"
      fontFamily="serif"
      fill="#92400E"
      opacity="0.85"
    >
      ₵
    </text>
  </svg>
);
